const media = () => {
    
    var carouselVideo = $(".media--video .media-slider")
    
    if(carouselVideo.length > 0) {
        
        var url;

        var sliderVideo = $(carouselVideo).slick({
            mobileFirst: true,
            arrows: false,
            slidesToShow: 1,
            infinite: false,
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 2
                  }
                }
            ]
        })

        $(".media--video #media-prev").click(function(){
            sliderVideo.slick("slickPrev");
        })

        $(".media--video #media-next").click(function(){
            sliderVideo.slick("slickNext");
        })
    }
    
    var carouselImages = $(".media--images .media-slider")
    
    if(carouselImages.length > 0) {
        
        

        var sliderImages = $(carouselImages).slick({
            mobileFirst: true,
            arrows: false,
            slidesToShow: 1.1,
            infinite: false,
            responsive: [
                {
                  breakpoint: 992,
                  settings: {
                    slidesToShow: 3
                  }
                }
            ]
        })

        $(".media--images #media-prev").click(function(){
            sliderImages.slick("slickPrev");
        })

        $(".media--images #media-next").click(function(){
            sliderImages.slick("slickNext");
        })
    }
    

	$('.popup-gallery').magnificPopup({
		delegate: 'a',
		type: 'image',
		tLoading: 'Ładowanie...',
		mainClass: 'mfp-img-mobile',
		gallery: {
			enabled: true,
			navigateByImgClick: true,
			preload: [0,1] // Will preload 0 - before current, and 1 after the current image
		},
		image: {
			tError: 'Obiekt nie mógł być załadowany.',
			titleSrc: function(item) {
				//return item.el.attr('title') + '<small>by Marsel Van Oosten</small>';
			}
		}
	});

    var videoNodes = document.getElementsByClassName('video-container')
    var urls;
    
    Array.prototype.forEach.call(videoNodes, function(el) {

        urls = el.getAttribute('data-link');
        
        insertVideo(el, urls)  
    });
    
    
    function insertVideo(item, url) {

        function getId(url) {
            var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
            var match = url.match(regExp);

            if (match && match[2].length == 11) {
                return match[2];
            } else {
                return 'error';
            }
        }

        var videoId = getId(url);


        var iframeMarkup = '<iframe width="560" height="315" src="//www.youtube.com/embed/' 
            + videoId + '" frameborder="0" allowfullscreen></iframe>';

        item.insertAdjacentHTML('afterBegin', iframeMarkup)

    }
    
};

module.exports = {
    media
};